import React, {Fragment, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import neverLandUtils from "../../utils/NeverLandUtils";
import noticeImage from "../../assets/images/relogin.png";
import {updateMyInfo} from "../../utils/NeverLandRestFULInterface";
import {useNavigate} from "react-router-dom";

const ReLoginNoticeModal = ({setShowReloginModal}) => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const closeModal = () => {
    setOpen(false);
    setShowReloginModal(false);
    // 로컬스토리지 저장
    neverLandUtils.commons.save('relogin_modal', {isOpen: false});
    // 재로그인
    updateMyInfo(navigate);
  }

  return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" onClose={closeModal}>
          <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
          </Transition.Child>

          <div className="fixed inset-0 z-40 w-screen overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                    className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all m-10 w-[26rem]">

                  <div>
                    <img src={noticeImage} alt="시스템 점검으로 인해 재로그인됩니다."/>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
  )
}

export default ReLoginNoticeModal;
